module.exports = {"benefits":"BENEFICIO","parking":"ESTACIONAMENTO","toll":"PEDAGIO","veloeServices":"MENSALIDADE"}


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/InvoiceDetailsListItems/data.json
// module id = 2071
// module chunks = 0